import axios from 'axios';
import vars from '@/config/vars';

const defaultHeaders = {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
};

const axiosConfig = axios.create({
    baseURL: vars.API_GATEWAY_URL,
    headers: defaultHeaders
});

export default axiosConfig;